import React from 'react';
import { isEmpty } from 'lodash';

import {
  Typography,
  Divider,
  Box,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import { commonStyles } from '../styles';

import {
  getProductName,
  getDate,
  getTimeWindow,
  formatCurrency
} from '../utils';
import ClickableTooltip from '../components/ClickableTooltip';
import FeatureFlip from '../components/FeatureFlip';

const useStyles = makeStyles(theme => ({
  ...commonStyles(theme),
  divider: {
    margin: theme.spacing(3, 0)
  },
  item: {
    marginRight: theme.spacing(1)
  },
  itemDisplayName: {
    marginRight: theme.spacing(0.5)
  },
}));

const Quote = ({service, quote, systemType}) => {
  const classes = useStyles();
  if (isEmpty(quote)) return null;

  const { product_sku, date, time } = service;
  const { quote_breakdown, currency, full_price } = quote;

  return (
    <div className={`${classes.form} ${classes.quoteForm}`}>
      <Typography variant="subtitle1" color="textSecondary" gutterBottom>HVAC Checkup Visit</Typography>
      <FeatureFlip
        feature='coSchedulingEnabled'
        on={null}
        off={<Typography variant="subtitle1">{getProductName(product_sku, systemType)}</Typography>}
      />
      <Divider className={classes.divider} />
      <FeatureFlip
        feature='coSchedulingEnabled'
        on={<div>Preferred date: {getDate(date)}</div>}
        off={<div>{getDate(date)}</div>}
      />
      <FeatureFlip
        feature='coSchedulingEnabled'
        on={<div>Preferred time selected: Between {getTimeWindow(time)}</div>}
        off={<div>Between {getTimeWindow(time)}</div>}
      />
      <Divider className={classes.divider} />
      {quote_breakdown.map((item, index) =>
        <Box
          mt={index ? 2 : 0}
          key={index}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          order={item.order}
        >
          <Box className={classes.item}>
            <span className={classes.itemDisplayName}>{item.display_name}</span>
            {item.tooltip_content &&
              <ClickableTooltip tooltip={item.tooltip_content} />
            }
          </Box>
          <Box>{formatCurrency(currency.symbol, item.amount)}</Box>
        </Box>
      )}
      <Divider className={classes.divider} />
      <Box display="flex">
        <Box flexGrow={1}>Your Total</Box>
        <Box>{formatCurrency(currency.symbol, full_price)}</Box>
      </Box>
    </div>
  );
}

export default Quote;
